import axios from "axios";

let Api = axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT
});
/* baseURL: "http://app.menubyte.loc/api"*/

export default Api;